import { Box } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ReactNode } from 'react';
import zeplinColor from '../../../theme/Color';

type CheckboxProps = {
  label: string | ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  icon?: ReactNode;
  checkedIcon?: ReactNode;
  disableFocusRipple?: boolean;
  indeterminateIcon?: ReactNode;
  indeterminate?: boolean;
};

const CustomCheckbox = ({
  label,
  checked,
  onChange,
  icon,
  checkedIcon,
  disableFocusRipple,
  indeterminateIcon,
  indeterminate,
}: CheckboxProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
            sx={{
              color: zeplinColor.BasicBlack,
              '&.Mui-checked': { color: zeplinColor.BasicBlack },
            }}
            icon={icon}
            checkedIcon={checkedIcon}
            disableFocusRipple={disableFocusRipple}
            indeterminateIcon={indeterminateIcon}
            indeterminate={indeterminate}
          />
        }
        label={label}
        labelPlacement='end'
        componentsProps={{
          typography: { style: { pointerEvents: 'none' } },
        }}
        style={{ color: zeplinColor.Neutral9 }}
      />
    </Box>
  );
};

export default CustomCheckbox;
